// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SubmitButton_spinner__womPA","spin":"SubmitButton_spin___4vLr","submitButton":"SubmitButton_submitButton__wmsL5","loading":"SubmitButton_loading__lGoVd"};